import { render, staticRenderFns } from "./GFormEndereco.vue?vue&type=template&id=047fe350"
import script from "./GFormEndereco.vue?vue&type=script&lang=js"
export * from "./GFormEndereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports